import React, { PropsWithChildren } from 'react';
import { useSiteState, useStyleStore } from '../../state/state';
import { Fade } from 'react-bootstrap';

type WhenReadyProps = {
}

export const WhenReady = ({ children }: PropsWithChildren<WhenReadyProps>) => {

    const { loaded: siteOk } = useSiteState();
    const { loaded: styleOk } = useStyleStore();

    return (
        <Fade in={siteOk && styleOk}>
            <div>
                {children}
            </div>
        </Fade>
    );
};
